export const key = (state) => state.closeTheLoop.key;